import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";
import { Link as RouterLink, useLocation } from "react-router-dom";

const CommonCTA = ({
  title = "Ready to Transform Your Business with Custom Application Development?",
  description = "Let our SAP experts help you plan, implement, and optimize your SAP environment with a modern and business-focused approach.",
  buttonText = "Contact Us Today",
}) => {
  const location = useLocation();
  const isAboutUs = location.pathname === "/about";
  return (
    <Box component="section" sx={styles.section}>
      <Box
        sx={{
          ...styles.ctaWrapper,
          bgcolor: isAboutUs ? "#011027" : "transparent",
        }}
      >
        {/* Gradient Glow */}
        <Box sx={styles.glowOne} />
        <Box sx={styles.glowTwo} />

        <Container maxWidth="lg">
          <Box sx={styles.content}>
            <Typography
              component="h3"
              sx={{
                ...styles.title,
                color: isAboutUs ? "#D6E8FF" : "#0a2540",
              }}
            >
              {title}
            </Typography>

            <Typography
              sx={{
                ...styles.description,
                color: isAboutUs ? "#A9B7C6" : "#4b647d",
              }}
            >
              {description}
            </Typography>

            <Button
              component={RouterLink}
              to="/contact-us"
              endIcon={<ArrowOutwardRoundedIcon />}
              sx={styles.button}
            >
              {buttonText}
            </Button>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

const styles = {
  //   section: {
  //     py: { xs: 6, md: 10 },
  //   },

  ctaWrapper: {
    position: "relative",
    overflow: "hidden",

    width: "100%",
    borderRadius: { xs: "0px", md: "0px" },

    // background: `
    //   radial-gradient(circle at top left, rgba(0,188,212,0.22), transparent 35%),
    //   radial-gradient(circle at bottom right, rgba(33,150,243,0.18), transparent 35%),
    //   linear-gradient(135deg, #f5fbff 0%, #eef7ff 45%, #e8f4ff 100%)
    // `,

    // borderTop: "1px solid rgba(0, 120, 255, 0.08)",
    // borderBottom: "1px solid rgba(0, 120, 255, 0.08)",
  },

  glowOne: {
    position: "absolute",
    top: -140,
    left: -100,

    width: 380,
    height: 380,

    borderRadius: "50%",

    background: "rgba(0, 188, 212, 0.14)",
    filter: "blur(90px)",
  },

  glowTwo: {
    position: "absolute",
    bottom: -180,
    right: -100,

    width: 420,
    height: 420,

    borderRadius: "50%",

    background: "rgba(33, 150, 243, 0.14)",
    filter: "blur(100px)",
  },

  content: {
    position: "relative",
    zIndex: 2,

    textAlign: "center",

    py: { xs: 7, md: 10 },

    maxWidth: "980px",
    mx: "auto",
  },

  title: {
    color: "#0a2540",

    fontWeight: 700,
    letterSpacing: "-0.04em",

    lineHeight: 1.15,

    mb: 3,

    fontSize: {
      xs: "1.2rem",
      sm: "1.4rem",
      md: "1.75rem",
    },
  },

  description: {
    color: "#4b647d",

    fontWeight: 400,

    lineHeight: 1.8,

    maxWidth: "800px",
    mx: "auto",

    mb: 5,

    fontSize: {
      xs: "0.9rem",
      sm: "1.1rem",
      md: "1.25rem",
    },
  },

  button: {
    px: { xs: 2.5, md: 2 },
    py: 1.2,

    minWidth: 230,

    borderRadius: "999px",

    background: "linear-gradient(135deg, #0755c9, #0077c8)",

    color: "#fff",

    fontSize: "15px",
    fontWeight: 700,
    textTransform: "none",

    boxShadow: "0 14px 34px rgba(0,125,210,0.24)",

    "&:hover": {
      background: "linear-gradient(135deg, #008fd0, #006cb8)",
      transform: "translateY(-3px)",
      boxShadow: "0 20px 42px rgba(0,125,210,0.3)",
    },

    transition: "all 0.3s ease",
  },
};

export default CommonCTA;
